// Cálculo de IVA — PORTE FIEL de Qualita.
//   - Por línea:    form.js:4280-4297 (calcularTotalDetalle, IVA incluido en el precio).
//   - Por cabecera: form.js:6035-6203 (cargarImpuestos, agrupa por tasa 10/5/0).
// CRÍTICO: el backend NO recalcula IVA al persistir (setTotales está comentado en
// ComprobanteVentaBusinessImpl:528/598). El front DEBE mandar estos montos calculados.

const round4 = (n) => Math.round((Number(n) || 0) * 10000) / 10000

// Devuelve {baseImponible, valor, valorExento} de una línea con IVA INCLUIDO en el total.
// porcentaje = tasa del impuesto (10, 5 o 0). fraccionExenta = parte exenta del ítem (normalmente 0).
export function imponibleLinea(totalItem, porcentaje, fraccionExenta = 0) {
  const total = Number(totalItem) || 0
  const pct = Number(porcentaje) || 0
  const exenta = Number(fraccionExenta) || 0

  let baseImponible
  if (pct && pct !== 0) {
    // base = ((total - exenta) / (100 + %)) * 100   (form.js:4282-4286)
    baseImponible = ((total - exenta) / (100 + pct)) * 100
  } else {
    baseImponible = total
  }
  baseImponible = round4(baseImponible)
  const valor = round4((baseImponible * pct) / 100)
  const valorExento = round4(total - (baseImponible + valor))
  return { baseImponible, valor, valorExento }
}

// Agrupa los montosImponibles a nivel cabecera por tasa (10/5/0). Port de cargarImpuestos.
// lineas: [{ totalItem, fraccionExenta?, montosImponibles:[{ tipoImpuesto:{porcentaje}, baseImponible }] }]
// Devuelve { montosImponibles:[{tipoImpuesto, total, baseImponible, valor}], montoTotal }.
export function imponiblesCabecera(lineas) {
  const grupos = {} // porcentaje -> { tipoImpuesto, sumBase, total }

  for (const d of lineas) {
    const mi = d?.montosImponibles?.[0]
    const ti = mi?.tipoImpuesto
    const pct = ti?.porcentaje
    if (!mi || pct == null) continue

    if (!grupos[pct]) grupos[pct] = { tipoImpuesto: ti, sumBase: 0, total: 0 }
    grupos[pct].sumBase += Number(mi.baseImponible) || 0
    const exenta = Number(d.fraccionExenta) || 0
    grupos[pct].total += (Number(d.totalItem) || 0) - (pct === 0 ? 0 : exenta)

    // La fracción exenta de una línea gravada se acumula en el grupo exento (form.js:6062-6066).
    if (exenta && pct !== 0) {
      if (!grupos[0]) grupos[0] = { tipoImpuesto: ti.tipoExento || ti, sumBase: 0, total: 0 }
      grupos[0].sumBase += exenta
      grupos[0].total += exenta
    }
  }

  const montosImponibles = Object.keys(grupos)
    .sort((a, b) => Number(b) - Number(a)) // 10, 5, 0
    .map((pct) => {
      const g = grupos[pct]
      const total = round4(g.total)
      const baseImponible = round4(g.sumBase)
      return { tipoImpuesto: g.tipoImpuesto, total, baseImponible, valor: round4(total - baseImponible) }
    })

  const montoTotal = montosImponibles.reduce((s, m) => s + m.total, 0)
  return { montosImponibles, montoTotal }
}
